import React, { lazy, Suspense } from 'react'
import { Switch, Route, useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import PermissionGuard2 from '../../../../Layout/PermissionGuard2';
import RequisitionList from '../Pages/RequisitionList'
import WorkInProgress from '../../../../GlobalModules/Utility/Components/WorkInProgress'
const AddRequisition = lazy(() => import('../Pages/AddRequisition'))
const RequisitionView = lazy(() => import('../Pages/RequisitionView'))
const EditRequisition = lazy(() => import('../Pages/EditRequisition'))

function RequisitionRoute() {
  const history = useHistory()
  return (
    <Switch>
      <Route
        exact
        path='/:lng/sales/requisitions'
        render={() => (
          <React.Fragment>
            <RequisitionList history={history} />
          </React.Fragment>
        )}
      />
      <Route
        exact
        path='/:lng/sales/requisitions/add'
        render={() => (
          <React.Fragment>
            <Suspense
              fallback={
                <div className='wrapper'>
                  <span>Loading</span>
                </div>
              }
            >
              <AddRequisition />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path='/:lng/sales/requisitions/view/:slack'
        render={(props) => (
          <React.Fragment>
            <Suspense
              fallback={
                <div className='wrapper'>
                  <span>Loading</span>
                </div>
              }
            >
              <RequisitionView {...props} />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path='/:lng/sales/requisitions/edit/:slack'
        render={(props) => (
          <React.Fragment>
            <Suspense
              fallback={
                <div className='wrapper'>
                  <span>Loading</span>
                </div>
              }
            >
              <EditRequisition {...props} />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path='/:lng/sales/requisitions/list'
        render={() => <WorkInProgress />}
      />
      <Route
        path='/:lng/sales/requisitions/:unknown'
        render={() => <WorkInProgress />}
      />
    </Switch>
  )
}

const mapStateToProps = (globalState) => ({
  userCredentials: globalState.LoginReducer.userCredentials,
  userEntryType: globalState.LoginReducer.userEntryType
})

export default connect(mapStateToProps)(RequisitionRoute)
